import api from '@/services/api'

import { apiErrorHandler } from '../utils/apiErrors'

const ATTRIBUTES_ENDPOINT = 'attributes/'

export default class AttributeAPI {
  /**
   * Instantiate a new `AttributeAPI`
   * @param {class} cls - The class to use to create objects.
   */
  constructor(cls) {
    this.cls = cls
  }

  /**
   * Factory method to create a new instance of `AttributeAPI`.
   * @param {class} cls - The class to use to create objects.
   **/
  static create(cls) {
    return new AttributeAPI(cls)
  }

  /**
   * Get the API Client.
   */
  get client() {
    return api.getApiClient()
  }

  /**
   * Get List of Attributes via the API
   *
   * @param {object} - Anonymous object to be destructured to local variables.
   * @returns {Promise} - Promise wrapping the API response data
   */
  async list() {
    return this.client
      .get(ATTRIBUTES_ENDPOINT)
      .then(response => response.data)
      .then(data => {
        return {
          ...data,
          results: data.results.map(this.cls.fromAPI),
        }
      })
      .catch(apiErrorHandler({ apiName: 'List Attributes API error' }))
  }
}
